export const states = [
  { id: 1, name: "آذربایجان شرقی" },
  { id: 2, name: "آذربایجان غربی" },
  { id: 3, name: "اردبیل" },
  { id: 4, name: "اصفهان" },
  { id: 5, name: "البرز" },
  { id: 6, name: "ایلام" },
  { id: 7, name: "بوشهر" },
  { id: 8, name: "تهران" },
  { id: 9, name: "چهارمحال و بختیاری" },
  { id: 10, name: "خراسان جنوبی" },
  { id: 11, name: "خراسان رضوی" },
  { id: 12, name: "خراسان شمالی" },
  { id: 13, name: "خوزستان" },
  { id: 14, name: "زنجان" },
  { id: 15, name: "سمنان" },
  { id: 31, name: "سیستان و بلوچستان" },
  { id: 16, name: "فارس" },
  { id: 17, name: "قزوین" },
  { id: 18, name: "قم" },
  { id: 19, name: "کردستان" },
  { id: 20, name: "کرمان" },
  { id: 21, name: "کرمانشاه" },
  { id: 22, name: "کهگیلویه و بویراحمد" },
  { id: 23, name: "گلستان" },
  { id: 24, name: "گیلان" },
  { id: 25, name: "لرستان" },
  { id: 26, name: "مازندران" },
  { id: 27, name: "مرکزی" },
  { id: 28, name: "هرمزگان" },
  { id: 29, name: "همدان" },
  { id: 30, name: "یزد" },
];

export const cities = [
  // آذربایجان شرقی
  { id: 1, stateId: 1, name: "تبریز" },
  { id: 2, stateId: 1, name: "مراغه" },
  { id: 3, stateId: 1, name: "میانه" },
  { id: 4, stateId: 1, name: "شبستر" },
  { id: 5, stateId: 1, name: "مرند" },
  { id: 6, stateId: 1, name: "جلفا" },
  { id: 7, stateId: 1, name: "سراب" },
  { id: 8, stateId: 1, name: "هادی‌شهر" },
  { id: 9, stateId: 1, name: "بناب" },
  { id: 10, stateId: 1, name: "تسوج" },
  { id: 11, stateId: 1, name: "اهر" },
  { id: 12, stateId: 1, name: "هریس" },
  { id: 13, stateId: 1, name: "هشترود" },
  { id: 14, stateId: 1, name: "ملکان" },
  { id: 15, stateId: 1, name: "بستان‌آباد" },
  { id: 16, stateId: 1, name: "ورزقان" },
  { id: 17, stateId: 1, name: "اسکو" },
  { id: 18, stateId: 1, name: "آذرشهر" },
  { id: 19, stateId: 1, name: "ممقان" },
  { id: 20, stateId: 1, name: "صوفیان" },
  { id: 21, stateId: 1, name: "ایلخچی" },
  { id: 22, stateId: 1, name: "خسروشاه" },
  { id: 23, stateId: 1, name: "باسمنج" },
  { id: 24, stateId: 1, name: "سهند" },
  { id: 25, stateId: 1, name: " عجب شیر" },

  // آذربایجان غربی
  { id: 24, stateId: 2, name: "ارومیه" },
  { id: 25, stateId: 2, name: "نقده" },
  { id: 26, stateId: 2, name: "ماکو" },
  { id: 27, stateId: 2, name: "تکاب" },
  { id: 28, stateId: 2, name: "خوی" },
  { id: 29, stateId: 2, name: "مهاباد" },
  { id: 30, stateId: 2, name: "سردشت" },
  { id: 31, stateId: 2, name: "چالدران" },
  { id: 32, stateId: 2, name: "بوکان" },
  { id: 33, stateId: 2, name: "میاندوآب" },
  { id: 34, stateId: 2, name: "سلماس" },
  { id: 35, stateId: 2, name: "شاهین‌دژ" },
  { id: 36, stateId: 2, name: "پیرانشهر" },
  { id: 37, stateId: 2, name: "اشنویه" },
  { id: 38, stateId: 2, name: "پلدشت" },

  // اردبیل
  { id: 39, stateId: 3, name: "اردبیل" },
  { id: 40, stateId: 3, name: "پارس‌آباد" },
  { id: 41, stateId: 3, name: "خلخال" },
  { id: 42, stateId: 3, name: "مشگین‌شهر" },
  { id: 43, stateId: 3, name: "نمین" },
  { id: 44, stateId: 3, name: "نیر" },
  { id: 45, stateId: 3, name: "گرمی" },

  // اصفهان
  { id: 1, stateId: 4, name: "اردستان" },
  { id: 2, stateId: 4, name: "آران و بیدگل" },
  { id: 3, stateId: 4, name: "اصفهان" },
  { id: 4, stateId: 4, name: "باغ بهادران" },
  { id: 5, stateId: 4, name: "حاجی‌آباد" },
  { id: 6, stateId: 4, name: "خوانسار" },
  { id: 7, stateId: 4, name: "خمینی‌شهر" },
  { id: 8, stateId: 4, name: "درچه" },
  { id: 9, stateId: 4, name: "دهاقان" },
  { id: 10, stateId: 4, name: "تودشک" },
  { id: 11, stateId: 4, name: "تیران" },
  { id: 12, stateId: 4, name: "علویجه" },
  { id: 13, stateId: 4, name: "عسگران" },
  { id: 14, stateId: 4, name: "کاشان" },
  { id: 15, stateId: 4, name: "کوهپایه" },
  { id: 16, stateId: 4, name: "مبارکه" },
  { id: 17, stateId: 4, name: "نجف‌آباد" },
  { id: 18, stateId: 4, name: "نایین" },
  { id: 19, stateId: 4, name: "نطنز" },
  { id: 20, stateId: 4, name: "سمیرم" },
  { id: 21, stateId: 4, name: "شهرضا" },
  { id: 22, stateId: 4, name: "شاهین شهر" },
  { id: 23, stateId: 4, name: "زرین‌شهر" },
  { id: 24, stateId: 4, name: "فلاورجان" },
  { id: 25, stateId: 4, name: "گلپایگان" },
  { id: 26, stateId: 4, name: "ورزنه" },
  { id: 27, stateId: 4, name: "چادگان " },
  { id: 27, stateId: 4, name: " بویین میاندشت " },

  // البرز
  { id: 334, stateId: 5, name: " کرج" },
  { id: 335, stateId: 5, name: "فردیس" },
  { id: 336, stateId: 5, name: "کمال‌شهر" },
  { id: 337, stateId: 5, name: "نظرآباد" },
  { id: 338, stateId: 5, name: "محمدشهر" },
  { id: 339, stateId: 5, name: "ماهدشت" },
  { id: 340, stateId: 5, name: "مشکین‌دشت" },
  { id: 341, stateId: 5, name: "هشتگرد" },
  { id: 342, stateId: 5, name: "چهارباغ" },
  { id: 343, stateId: 5, name: "شهر جدید هشتگرد" },
  { id: 344, stateId: 5, name: "گرمدره" },
  { id: 346, stateId: 5, name: "کوهسار" },
  { id: 347, stateId: 5, name: "گلسار" },
  { id: 350, stateId: 5, name: "آسارا" },
  { id: 351, stateId: 5, name: "پلنگ‌آباد" },

  // ایلام
  { id: 70, stateId: 6, name: "ایلام" },
  { id: 71, stateId: 6, name: "مهران" },
  { id: 72, stateId: 6, name: "دهلران" },
  { id: 73, stateId: 6, name: "آبدانان" },
  { id: 74, stateId: 6, name: "دره‌شهر" },
  { id: 75, stateId: 6, name: "ایوان" },
  { id: 76, stateId: 6, name: "سرابله" },

  // بوشهر
  { id: 77, stateId: 7, name: "بوشهر" },
  { id: 18, stateId: 7, name: "برازجان" },
  { id: 19, stateId: 7, name: "دیر" },
  { id: 80, stateId: 7, name: "کنگان" },
  { id: 81, stateId: 7, name: "گناوه" },
  { id: 82, stateId: 7, name: "خورموج" },
  { id: 83, stateId: 7, name: "اهرم" },
  { id: 84, stateId: 7, name: "برازجان" },
  { id: 85, stateId: 7, name: "جم" },
  { id: 86, stateId: 7, name: "کاکی" },
  { id: 87, stateId: 7, name: "عسلویه" },

  // تهران
  { id: 87, stateId: 8, name: "تهران" },
  { id: 88, stateId: 8, name: "ورامین" },
  { id: 90, stateId: 8, name: "ری" },
  { id: 91, stateId: 8, name: "دماوند" },
  { id: 92, stateId: 8, name: "اسلامشهر" },
  { id: 93, stateId: 8, name: "رودهن" },
  { id: 94, stateId: 8, name: "لواسان" },
  { id: 95, stateId: 8, name: "بومهن" },
  { id: 96, stateId: 8, name: "تجریش" },
  { id: 97, stateId: 8, name: "فشم" },
  { id: 98, stateId: 8, name: "کهریزک" },
  { id: 99, stateId: 8, name: "پاکدشت" },
  { id: 100, stateId: 8, name: "چهاردانگه" },
  { id: 102, stateId: 8, name: "قرچک" },
  { id: 103, stateId: 8, name: "باقرشهر" },
  { id: 104, stateId: 8, name: "شهریار" },
  { id: 105, stateId: 8, name: "رباط‌کریم" },
  { id: 106, stateId: 8, name: "قدس" },
  { id: 107, stateId: 8, name: "ملارد" },
  { id: 108, stateId: 8, name: "پردیس" },

  // چهارمحال بختیاری
  { id: 108, stateId: 9, name: "شهرکرد" },
  { id: 109, stateId: 9, name: "فارسان" },
  { id: 110, stateId: 9, name: "فرخشهر" },
  { id: 111, stateId: 9, name: "بروجن" },
  { id: 112, stateId: 9, name: "چلگرد" },
  { id: 113, stateId: 9, name: "اردل" },
  { id: 114, stateId: 9, name: "لردگان" },

  // خراسان جنوبی
  { id: 114, stateId: 10, name: "قائن" },
  { id: 115, stateId: 10, name: "فردوس" },
  { id: 116, stateId: 10, name: "بیرجند" },
  { id: 117, stateId: 10, name: "نهبندان" },
  { id: 118, stateId: 10, name: "سربیشه" },
  { id: 119, stateId: 10, name: "طبس" },

  //  خراسان رضوی
  { id: 120, stateId: 11, name: "مشهد" },
  { id: 121, stateId: 11, name: "نیشابور" },
  { id: 122, stateId: 11, name: "سبزوار" },
  { id: 123, stateId: 11, name: "کاشمر" },
  { id: 124, stateId: 11, name: "گناباد" },
  { id: 125, stateId: 11, name: "تربت‌ حیدریه" },
  { id: 126, stateId: 11, name: "خواف" },
  { id: 127, stateId: 11, name: "تربت‌جام" },
  { id: 128, stateId: 11, name: "تایباد" },
  { id: 129, stateId: 11, name: "قوچان" },
  { id: 130, stateId: 11, name: "سرخس" },
  { id: 131, stateId: 11, name: "فریمان" },
  { id: 132, stateId: 11, name: "چناران" },
  { id: 133, stateId: 11, name: "درگز" },
  { id: 134, stateId: 11, name: "طرقبه" },
  { id: 135, stateId: 11, name: "جغتای" },
  { id: 136, stateId: 11, name: "گلبهار" },
  { id: 137, stateId: 11, name: "شاندیز" },

  // خراسان شمالی
  { id: 135, stateId: 12, name: "بجنورد" },
  { id: 136, stateId: 12, name: "اسفراین" },
  { id: 137, stateId: 12, name: "جاجرم" },
  { id: 138, stateId: 12, name: "شیروان" },
  { id: 139, stateId: 12, name: "فاروج" },
  { id: 140, stateId: 12, name: "آشخانه" },

  // خوزستان
  { id: 140, stateId: 13, name: "اهواز" },
  { id: 141, stateId: 13, name: "ایرانشهر" },
  { id: 142, stateId: 13, name: "شوش" },
  { id: 143, stateId: 13, name: "آبادان" },
  { id: 144, stateId: 13, name: "خرمشهر" },
  { id: 145, stateId: 13, name: "مسجدسلیمان" },
  { id: 146, stateId: 13, name: "ایذه" },
  { id: 147, stateId: 13, name: "شوشتر" },
  { id: 148, stateId: 13, name: "اندیمشک" },
  { id: 149, stateId: 13, name: "سوسنگرد" },
  { id: 150, stateId: 13, name: "هویزه" },
  { id: 151, stateId: 13, name: "دزفول" },
  { id: 152, stateId: 13, name: "شادگان" },
  { id: 153, stateId: 13, name: "بندرماهشهر" },
  { id: 154, stateId: 13, name: "بندرامام خمینی" },
  { id: 155, stateId: 13, name: "بهبهان" },
  { id: 156, stateId: 13, name: "رامهرمز" },
  { id: 157, stateId: 13, name: "باغ‌ملک" },
  { id: 158, stateId: 13, name: "هندیجان" },
  { id: 159, stateId: 13, name: "لالی" },
  { id: 160, stateId: 13, name: "رامشیر" },
  { id: 161, stateId: 13, name: "حمیدیه" },
  { id: 162, stateId: 13, name: "ملاثانی" },

  // زنجان
  { id: 163, stateId: 14, name: "زنجان" },
  { id: 164, stateId: 14, name: "ابهر" },
  { id: 165, stateId: 14, name: "خدابنده" },
  { id: 166, stateId: 14, name: "ماهنشان" },
  { id: 167, stateId: 14, name: "خرمدره" },
  { id: 168, stateId: 14, name: "آب‌بر" },
  { id: 169, stateId: 14, name: "قیدار" },

  // سمنان
  { id: 170, stateId: 15, name: "سمنان" },
  { id: 171, stateId: 15, name: "شاهرود" },
  { id: 172, stateId: 15, name: "گرمسار" },
  { id: 173, stateId: 15, name: "ایوانکی" },
  { id: 174, stateId: 15, name: "دامغان" },
  { id: 175, stateId: 15, name: "بسطام" },

  // فارس
  { id: 183, stateId: 16, name: "شیراز" },
  { id: 184, stateId: 16, name: "اقلید" },
  { id: 185, stateId: 16, name: "داراب" },
  { id: 186, stateId: 16, name: "فسا" },
  { id: 187, stateId: 16, name: "مرودشت" },
  { id: 188, stateId: 16, name: "آباده" },
  { id: 189, stateId: 16, name: "کازرون" },
  { id: 190, stateId: 16, name: "سپیدان" },
  { id: 191, stateId: 16, name: "لار" },
  { id: 192, stateId: 16, name: "فیروزآباد" },
  { id: 193, stateId: 16, name: "جهرم" },
  { id: 194, stateId: 16, name: "استهبان" },
  { id: 195, stateId: 16, name: "لامرد" },
  { id: 196, stateId: 16, name: "مهر" },
  { id: 197, stateId: 16, name: "اردکان" },
  { id: 198, stateId: 16, name: "صفاشهر" },
  { id: 199, stateId: 16, name: "ارسنجان" },
  { id: 200, stateId: 16, name: "سوریان" },
  { id: 201, stateId: 16, name: "فراشبند" },
  { id: 202, stateId: 16, name: "سروستان" },
  { id: 203, stateId: 16, name: "زرقان" },
  { id: 204, stateId: 16, name: "کوار" },
  { id: 205, stateId: 16, name: "بوانات" },
  { id: 206, stateId: 16, name: "خرامه" },
  { id: 207, stateId: 16, name: "خنج" },
  { id: 208, stateId: 16, name: "نور آباد" },
  { id: 209, stateId: 16, name: "نیریز" },
  { id: 210, stateId: 16, name: "قیر" },
  { id: 211, stateId: 16, name: "گراش" },

  // قزوین
  { id: 208, stateId: 17, name: "قزوین" },
  { id: 209, stateId: 17, name: "تاکستان" },
  { id: 210, stateId: 17, name: "آبیک" },
  { id: 211, stateId: 17, name: "بوئین‌زهرا" },

  // قم
  { id: 212, stateId: 18, name: "قم" },
  { id: 213, stateId: 18, name: "قنوات" },
  { id: 214, stateId: 18, name: "جعفریه" },
  { id: 215, stateId: 18, name: "کهک" },
  { id: 216, stateId: 18, name: "دستجرد" },
  { id: 217, stateId: 18, name: "سلفچگان" },

  // کردستان
  { id: 218, stateId: 19, name: "سنندج" },
  { id: 219, stateId: 19, name: "بانه" },
  { id: 220, stateId: 19, name: "بیجار" },
  { id: 221, stateId: 19, name: "سقز" },
  { id: 222, stateId: 19, name: "قروه" },
  { id: 223, stateId: 19, name: "مریوان" },
  { id: 224, stateId: 19, name: "صلوات‌آباد" },
  { id: 225, stateId: 19, name: "حسن‌آباد" },
  { id: 226, stateId: 19, name: "کامیاران" },

  // کرمان
  { id: 226, stateId: 20, name: "کرمان" },
  { id: 228, stateId: 20, name: "انار" },
  { id: 231, stateId: 20, name: "بافت" },
  { id: 237, stateId: 20, name: "بردسیر" },
  { id: 235, stateId: 20, name: "بم" },
  { id: 236, stateId: 20, name: "جیرفت" },
  { id: 227, stateId: 20, name: "راور" },
  { id: 230, stateId: 20, name: "رفسنجان" },
  { id: 234, stateId: 20, name: "زرند" },
  { id: 232, stateId: 20, name: "سیرجان" },
  { id: 238, stateId: 20, name: "شهربابک" },
  { id: 229, stateId: 20, name: "کوهبنان" },
  { id: 233, stateId: 20, name: "کهنوج" },

  // کرمانشاه
  { id: 238, stateId: 21, name: "کرمانشاه" },
  { id: 239, stateId: 21, name: "اسلام‌آباد غرب" },
  { id: 240, stateId: 21, name: "کنگاور" },
  { id: 241, stateId: 21, name: "سنقر" },
  { id: 242, stateId: 21, name: "قصرشیرین" },
  { id: 243, stateId: 21, name: "هرسین" },
  { id: 244, stateId: 21, name: "صحنه" },
  { id: 245, stateId: 21, name: "پاوه" },
  { id: 246, stateId: 21, name: "جوانرود" },
  { id: 247, stateId: 21, name: "گیلانغرب" },

  // بویر احمد
  { id: 247, stateId: 22, name: "یاسوج" },
  { id: 248, stateId: 22, name: "گچساران" },
  { id: 249, stateId: 22, name: "دوگنبدان" },
  { id: 250, stateId: 22, name: "سی‌سخت" },
  { id: 251, stateId: 22, name: "دهدشت" },

  //  گلستان
  { id: 252, stateId: 23, name: "گرگان" },
  { id: 253, stateId: 23, name: "آق‌قلا" },
  { id: 271, stateId: 23, name: "بندرترکمن" },
  { id: 254, stateId: 23, name: "گنبدکاووس" },
  { id: 255, stateId: 23, name: "علی‌آباد کتول" },
  { id: 256, stateId: 23, name: "کردکوی" },
  { id: 257, stateId: 23, name: "کلاله" },
  { id: 258, stateId: 23, name: "آزادشهر" },
  { id: 259, stateId: 23, name: "رامیان" },
  { id: 270, stateId: 23, name: "مینودشت" },

  // گیلان
  { id: 264, stateId: 24, name: "آستارا" },
  { id: 265, stateId: 24, name: "آستانه اشرفیه" },
  { id: 272, stateId: 24, name: "املش" },
  { id: 274, stateId: 24, name: "بندرانزلی" },
  { id: 263, stateId: 24, name: "تالش" },
  { id: 267, stateId: 24, name: "فومن" },
  { id: 273, stateId: 24, name: "لاهیجان" },
  { id: 262, stateId: 24, name: "لنگرود" },
  { id: 270, stateId: 24, name: "ماسال" },
  { id: 266, stateId: 24, name: "ماسوله" },
  { id: 261, stateId: 24, name: "منجیل" },
  { id: 280, stateId: 24, name: "رودبار" },
  { id: 260, stateId: 24, name: "رشت" },
  { id: 300, stateId: 24, name: "رودسر" },
  { id: 301, stateId: 24, name: "رضوانشهر" },
  { id: 271, stateId: 24, name: "شفت" },
  { id: 268, stateId: 24, name: "صومعه‌سرا" },
  { id: 269, stateId: 24, name: "هشتپر" },

  // لرستان
  { id: 274, stateId: 25, name: "خرم‌آباد" },
  { id: 275, stateId: 25, name: "ماهشهر" },
  { id: 276, stateId: 25, name: "دزفول" },
  { id: 277, stateId: 25, name: "بروجرد" },
  { id: 278, stateId: 25, name: "دورود" },
  { id: 279, stateId: 25, name: "الیگودرز" },
  { id: 280, stateId: 25, name: "ازنا" },
  { id: 281, stateId: 25, name: "نورآباد" },
  { id: 282, stateId: 25, name: "کوهدشت" },
  { id: 283, stateId: 25, name: "الشتر" },

  // مازندران
  { id: 284, stateId: 26, name: "ساری" },
  { id: 285, stateId: 26, name: "آمل" },
  { id: 286, stateId: 26, name: "بابل" },
  { id: 287, stateId: 26, name: "بابلسر" },
  { id: 288, stateId: 26, name: "بهشهر" },
  { id: 289, stateId: 26, name: "تنکابن" },
  { id: 290, stateId: 26, name: "جویبار" },
  { id: 291, stateId: 26, name: "چالوس" },
  { id: 292, stateId: 26, name: "رامسر" },
  { id: 293, stateId: 26, name: "قائم‌شهر" },
  { id: 294, stateId: 26, name: "نکا" },
  { id: 295, stateId: 26, name: "نور" },
  { id: 296, stateId: 26, name: "بلده" },
  { id: 297, stateId: 26, name: "نوشهر" },
  { id: 298, stateId: 26, name: "محمودآباد" },
  { id: 299, stateId: 26, name: "فریدون کنار" },
  { id: 300, stateId: 26, name: "کلاردشت" },

  // مرکزی
  { id: 299, stateId: 27, name: "اراک" },
  { id: 300, stateId: 27, name: "آشتیان" },
  { id: 301, stateId: 27, name: "تفرش" },
  { id: 302, stateId: 27, name: "خمین" },
  { id: 303, stateId: 27, name: "خنداب" },
  { id: 304, stateId: 27, name: "دلیجان" },
  { id: 305, stateId: 27, name: "ساوه" },
  { id: 306, stateId: 27, name: "محلات" },
  { id: 307, stateId: 27, name: "شازند" },

  // هرمزگان
  { id: 307, stateId: 28, name: "بندرعباس" },
  { id: 308, stateId: 28, name: "بندرلنگه" },
  { id: 309, stateId: 28, name: "حاجی‌آباد" },
  { id: 310, stateId: 28, name: "دهبارز" },
  { id: 311, stateId: 28, name: "میناب" },
  { id: 312, stateId: 28, name: "بندر جاسک" },
  { id: 313, stateId: 28, name: "بندر خمیر" },
  { id: 314, stateId: 28, name: "پارسیان" },

  // همدان
  { id: 317, stateId: 29, name: "همدان" },
  { id: 318, stateId: 29, name: "ملایر" },
  { id: 319, stateId: 29, name: "نهاوند" },
  { id: 320, stateId: 29, name: "رزن" },
  { id: 321, stateId: 29, name: "اسدآباد" },
  { id: 322, stateId: 29, name: "بهار" },
  { id: 323, stateId: 29, name: "کبودراهنگ" },
  { id: 324, stateId: 29, name: "تویسرکان" },

  // یزد
  { id: 323, stateId: 30, name: "یزد" },
  { id: 324, stateId: 30, name: "تفت" },
  { id: 325, stateId: 30, name: "اردکان" },
  { id: 326, stateId: 30, name: "ابرکوه" },
  { id: 327, stateId: 30, name: "میبد" },
  { id: 328, stateId: 30, name: "بافق" },
  { id: 329, stateId: 30, name: "مهریز" },
  { id: 330, stateId: 30, name: "اشکذر" },
  { id: 331, stateId: 30, name: "هرات" },
  { id: 332, stateId: 30, name: "خضرآباد" },
  { id: 333, stateId: 30, name: "زارچ" },

  // سیستان و بلوچستان
  { id: 400, stateId: 31, name: "زابل" },
  { id: 401, stateId: 31, name: "زاهدان" },
];
